import Vue from "vue";
import Vuex from "vuex";
import logger from "vuex/dist/logger";
import * as ACTIONS from "./actions";
import * as GETTERS from "./getters";
import dataService from "../ml/services/dataService";
import presentationService from "../ml/services/presentationService";
import Cookies from "js-cookie";
import {find, findIndex, isBoolean, isObject, isUndefined, orderBy} from 'lodash';
import storejs from 'store/dist/store.modern.min';
import Bugsnag from "@bugsnag/js";
import helpScoutService from '../ml/services/helpScoutService';
import userPermissionService from '../v2/app/services/userPermissionService';
//storejs.addPlugin(require('store/plugins/compression'));
storejs.addPlugin(require('store/plugins/defaults'));
storejs.addPlugin(require('store/plugins/dump'));
storejs.addPlugin(require('store/plugins/events'));
storejs.addPlugin(require('store/plugins/expire'));
storejs.addPlugin(require('store/plugins/json2'));
storejs.addPlugin(require('store/plugins/observe'));
storejs.addPlugin(require('store/plugins/operations'));
storejs.addPlugin(require('store/plugins/update'));

Vue.use(Vuex);

const SIDEBAR_KEY = 'sidebarOpen';

let token = document.head.querySelector('meta[name="csrf-token"]');

const state = {
  accountManager: null, // MLD-5199
  accountManagers: [], // MLD-5199
  announcements: [],
  csrfToken: token ? token.content : Cookies.get('XSRF-TOKEN'),
  title: 'Mobile Locker',
  botResult: null, // MLD-5093
  brands: [], // MLD-4796
  cart: [],
  contacts: [],
  countries: [],
  currentEvent: null,
  //currentPresentation: null,
  //currentPresentationID: null,
  currentTeamID: null,
  currentTeam: null,
  devices: [],
  deviceTypes: dataService.deviceTypes(),
  folders: [],
  groups: [],
  importUsers: [],
  labels: [],
  lastRefreshedApiTokenAt: null,
  loadingNotifications: false,
  locales: [],
  notifications: [],
  organizations: [],
  permissions: userPermissionService.getDefaultPermissions(), // MLD-5518
  presentations: [],
  presentation_filter: presentationService.resetFilter(),
  presentationStatusCodes: dataService.presentationStatusCodes(),
  presentationTypes: presentationService.getTypes(),
  products: [], // MLD-3306
  query: null, // MLD-2035
  reloadRequired: false, // MLD-915
  team_roles: dataService.teamRoles(),
  shareTemplates: [],
  shareThemes: [], // MLD-967
  sidebarOpen: (false === isUndefined(storejs.get(SIDEBAR_KEY))) ? storejs.get(SIDEBAR_KEY) : true,
  spark: {},
  subscriptions: [],
  teams: [],
  timezones: [],
  triggerEvents: [
    {id: 'device_event', name: 'an event comes in from the iOS app'},
    {id: 'card.verified', name: 'A scanned business card is verified'},
  ],
  loadingUsers: false, // MLD-3690
  user: (window.ML) ? window.ML.user : null,
  users: [],
  userStatusCodes: dataService.userStatusCodes(),
  emailCreditInfo: { // MLD-6180
    enabled: false,
    total_credits: 0,
    available_credits: 0,
    loaded: false,
  },
};

const mutations = {
  setAccountManager(state, accountManager) { // MLD-5199
    state.accountManager = accountManager;
  },
  setAccountManagers(state, accountManagers) { // MLD-5199
    state.accountManagers = accountManagers;
  },
  setBotResult(state, botResult) { // MLD-5098
    state.botResult = botResult;
  },
  setCsrfToken(state, csrfToken) { // MLD-4934
    state.csrfToken = csrfToken;
  },
  setBrands(state, brands) { // MLD-4796
    state.brands = brands;
  },
  RESET_PRESENTATION_FILTER(state) {
    this.SET_PRESENTATION_FILTER(state, presentationService.resetFilter());
  },
  SET_PRESENTATION_FILTER(state, filter) {
    state.presentation_filter = filter;
    storejs.set('presentation_filter', filter);
  },
  CLOSE_SIDEBAR(state) {
    state.sidebarOpen = false;
    storejs.set(SIDEBAR_KEY, state.sidebarOpen);
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarOpen = !state.sidebarOpen;
    storejs.set(SIDEBAR_KEY, state.sidebarOpen);
  },
  ADD_TO_CART(state, item) {
    let index = findIndex(state.cart, (i) => {
      return i.id === item.id
    });
    if (index > -1) {
      state.cart[index] = item;
    } else {
      state.cart.push(item);
    }
  },
  EMPTY_CART(state) {
    state.cart = [];
  },
  READ_NOTIFICATIONS(state) {
    state.notifications.forEach(n => {
      n.read = 1;
    })
  },
  READ_NOTIFICATION(state, notification) {
    notification.read = 1;
    let index = findIndex(state.notifications, (n) => {
      return n.id === notification.id;
    });
    notification.read = 1;
    if (index > -1) {
      state.notifications[index].read = 1;
    } else {
      state.notifications.push(notification);
    }
  },
  SET_ANNOUNCEMENTS(state, announcements) {
    state.announcements = announcements;
  },
  SET_CONTACTS(state, contacts) {
    state.contacts = contacts;
  },
  SET_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  SET_CURRENT_EVENT(state, event) {
    state.currentEvent = event;
  },
  setPermissions(state, permissions) { // MLD-5518
    state.permissions = permissions;
  },
  setProducts(state, products) { // MLD-3306
    state.products = products;
  },
  SET_CURRENT_USER(state, currentUser) {
    if (currentUser) {
      if ("Bugsnag" in window) {
        Bugsnag.setUser(currentUser.id, currentUser.email, currentUser.name);
      } // MLD-3045
    } else {
      if ("Bugsnag" in window) {
        Bugsnag.setUser(null, null, null);
      }
    }
    state.user = currentUser;
    state.currentTeamID = currentUser.current_team_id;
    let team = find(state.teams, t => t.id === currentUser.current_team_id);
    if (team) {
      state.currentTeam = team;
      state.user.team_name = team.name; // MLD-3837
      state.user.team_role = team.pivot.role;
      state.user.team_member = ('Team Member' === team.pivot.role);
      state.user.team_admin = ('Team Admin' === team.pivot.role);
      state.user.team_permissions = team.pivot.permissions;
    } else {
      state.currentTeam = null;
      state.user.team_name = null; // MLD-3837
      state.user.team_member = true;
      state.user.team_role = null;
      state.user.team_admin = false;
      state.user.team_permissions = {};
    }

    state.user.hasPermission = function (permission) {
      if (this.team_admin) {
        //console.log(`${this.name} is a Team Admin or Team Support and therefore has permission ${permission}`);
        return true;
      }
      if (isObject(this.team_permissions) && isBoolean(this.team_permissions[permission])) {
        return this.team_permissions[permission];
      }
      console.log(`Permission ${permission} does not exist`);
      return false;
    };
    state.user.hasRole = function (role) {
      let index = findIndex(state.user.roles, r => {
        return r.name === role;
      });
      return index !== -1;
    }

    // MLD-3837
    helpScoutService.identify(state.user);
  },
  SET_DEVICE(state, device) {
    let index = findIndex(state.devices, (d) => {
      return d.id === device.id
    });
    if (index === -1) {
      state.devices.push(device);
    } else {
      state.devices[index] = device;
    }
  },
  SET_DEVICES(state, devices) {
    state.devices = devices;
  },
  SET_FOLDERS(state, folders) {
    state.folders = folders;
  },
  SET_GROUP(state, group) {
    let index = findIndex(state.groups, g => g.id === group.id);
    if (index === -1) {
      state.groups.push(group);
    } else {
      state.groups[index] = group;
    }
    state.groups = orderBy(state.groups, ['slug'], ['asc']);
  },
  SET_GROUPS(state, groups) {
    state.groups = orderBy(groups, ['slug'], ['asc']);
  },
  SET_IMPORT_USERS(state, importUsers) {
    state.importUsers = importUsers;
  },
  SET_LABEL(state, label) {
    let index = findIndex(state.labels, (l) => {
      return l.id === label.id
    });
    if (index === -1) {
      state.labels.push(label);
    } else {
      state.labels[index] = label;
    }
    state.labels = orderBy(state.labels, ['slug'], ['asc']);
  },
  SET_LABELS(state, labels) {
    labels.forEach((label) => {
      label.editing = false;
    });
    state.labels = orderBy(labels, ['slug'], ['asc']);
  },
  SET_LOCALES(state, locales) {
    state.locales = orderBy(locales, ['name'], ['asc']);
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations;
  },
  /**
   * @deprecated
   * @param state
   * @param presentation
   * @constructor
   */
  SET_PRESENTATION(state, presentation) {
    let index = findIndex(state.presentations, p => {
      return p.id === presentation.id
    });

    if (index === -1) {
      state.presentations.push(presentation);
    } else {
      state.presentations[index] = presentation;
    }
    state.presentations = orderBy(state.presentations, ['slug'], ['asc']);
  },
  SET_PRESENTATION_COMMENT_COUNT(state, commentCount) {
    const presentation = state.currentPresentation;
    if (presentation) {
      presentation.comment_count = commentCount;
      //console.log(`Presentation ${presentation.id} now has ${commentCount} comments.`);
    }
  },
  SET_PRESENTATION_SUBSCRIBERS(state, subscribers) {
    const presentation = state.currentPresentation;
    if (presentation) {
      presentation.subscribers = subscribers;
    }
  },
  SET_PRESENTATION_SUBSCRIBER_COUNT(state, subscriberCount) {
    const presentation = state.currentPresentation;
    if (presentation) {
      presentation.subscriber_count = subscriberCount;
      //console.log(`Presentation ${presentation.id} now has ${subscriberCount} subscribers.`);
    }
  },
  SET_PRESENTATIONS(state, presentations) {
    state.presentations = orderBy(presentations, ['slug'], ['asc']);
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  SET_RELOAD_REQUIRED(state, reloadRequired) { // MLD-915
    state.reloadRequired = reloadRequired;
  },
  SET_SHARE_TEMPLATES(state, shareTemplates) {
    state.shareTemplates = shareTemplates;
  },
  SET_SHARE_THEMES(state, shareThemes) { // MLD-967
    state.shareThemes = shareThemes;
  },
  SET_SPARK(state, spark) {
    state.spark = spark;
  },
  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions;
  },
  SET_TEAM(state, team) {
    if (team.id === state.currentTeamID) {
      state.currentTeam = team;
    }
    let index = findIndex(state.teams, (t) => {
      return t.id === team.id
    });
    if (index === -1) {
      state.teams.push(team);
    } else {
      state.teams[index] = team;
    }
  },
  SET_TEAMS(state, teams) {
    state.teams = orderBy(teams, ['slug'], ['asc']);
  },
  SET_TIMEZONES(state, timezones) {
    state.timezones = timezones;
  },
  SET_TITLE(state, title) {
    //console.log('SET_TITLE mutation', title);
    state.title = title;
  },
  loadingUsers(state, loadingUsers) { // MLD-3690
    state.loadingUsers = loadingUsers;
  },
  SET_USER(state, user) {
    let index = findIndex(state.users, (u) => {
      return u.id === user.id;
    });
    if (index === -1) {
      state.users.push(user);
    } else {
      state.users[index] = user;
    }
    state.users = orderBy(state.users, ['slug'], ['asc']);
  },
  SET_USERS(state, users) {
    state.users = orderBy(users, ['slug'], ['asc']);
  },
  setEmailCreditInfo(state, emailCreditInfo) { // MLD-6180
    state.emailCreditInfo = emailCreditInfo;
  }
};

const debug = process.env.NODE_ENV !== 'production';

// See https://github.com/vuejs/vuex/blob/dev/examples/shopping-cart/store/index.js
export default new Vuex.Store({
  actions: ACTIONS,
  getters: GETTERS,
  mutations,
  state,
  strict: debug,
  plugins: debug ? [logger] : []
});
